import { render, staticRenderFns } from "./RolesAssignment.vue?vue&type=template&id=3896bc5c&"
import script from "./RolesAssignment.vue?vue&type=script&lang=js&"
export * from "./RolesAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports